export const updateBookingStatusEndpoint = '/berths/booking/update_status' as const
